/* unplugin-vue-components disabled */import { render } from "./ProductExpansionIntro.vue?vue&type=template&id=11795e31"
const script = {}

import exportComponent from "/home/kenandlyhael/www/salehoo-mi/salehoo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__